import { HomeTwoTone } from '@mui/icons-material';
import {
  Box,
  Breadcrumbs,
  Link as MLink,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { PointsContainer } from '../container/PointsContainer';
import { useUserCheckPermission } from '../hooks/useUserCheckPermission';

export default function PointsPage() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const { can } = useUserCheckPermission();

  return (
    <Box>
      <PageHeader title={t('pointsPage.title')} />
      <Breadcrumbs sx={{ mb: 2 }}>
        <MLink
          component={Link}
          to="/"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <HomeTwoTone />
        </MLink>
        <MLink component={Link} to="/account">
          {t('nav.account')}
        </MLink>
        <Typography>{t('pointsPage.title')}</Typography>
      </Breadcrumbs>
      <Box>
        {can('getMemberIndividualPointTransaction') && <PointsContainer />}
      </Box>
    </Box>
  );
}
